import { cancelPayment } from 'api/rest/payments/cancelPayment';
import { getPayment } from 'api/rest/payments/getPayment';
import { notifyAboutClientPayment } from 'api/rest/payments/notifyAboutClientPayment';
import { setPaymentName } from 'api/rest/payments/setPaymentName';
import { setPaymentStatus } from 'api/rest/payments/setPaymentStatus';
import { Deposit, DepositStatus } from 'data/payments/models';
import { getDataAtom } from 'utils/atoms/dataAtom';
import {
  getDataFetchingAtom,
  getDataRefreshingAtom,
  getFormStateAtom,
  getFormUpdatingAtom,
} from 'utils/atoms/dataFetchingAtom';
import { mapAtomValue } from 'utils/remote';

import { storeDepositLoadTimes } from '../../api/rest/payments/storeLoadTimes';

export const paymentAtom = getDataAtom<Deposit>();

export const fetchPaymentAtom = getDataFetchingAtom(
  paymentAtom,
  async (paymentId: string) => {
    const payment = await getPayment(paymentId);
    storeDepositLoadTimes(paymentId, '/public/payments');

    return payment;
  },
);
export const refreshPaymentAtom = getDataRefreshingAtom(
  paymentAtom,
  getPayment,
);

export const paymentFormAtom = getFormStateAtom();

export const setPaymentNameAtom = getFormUpdatingAtom(
  async (body: { depositId: string; payerName: string }) => {
    const result = await setPaymentName(body);
    if (result.paymentLink) {
      window.location.href = result.paymentLink;
    }
    return result;
  },
  paymentAtom,
  paymentFormAtom,
);

export const setPaymentStatusAtom = getFormUpdatingAtom(
  async (
    {
      depositId,
      status,
    }: {
      depositId: string;
      status: DepositStatus;
    },
    _,
    set,
  ) => {
    await setPaymentStatus(depositId, status);
    return set(
      paymentAtom,
      mapAtomValue((payment) => ({ ...payment, status })),
    );
  },
);

export const notifyAboutClientPaymentAtom = getFormUpdatingAtom(
  async ({ depositId }: { depositId: string }) => {
    await notifyAboutClientPayment(depositId);
  },
);

export const cancelPaymentAtom = getFormUpdatingAtom(
  async ({ depositId }: { depositId: string }) => {
    await cancelPayment(depositId);
  },
);
